import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get } from "services/api";

// Units
const LOAD_EVENTS_GIOTANK_GRAPH = "LOAD_EVENTS_GIOTANK_GRAPH";
const SET_EVENTS_GIOTANK_GRAPH = "SET_EVENTS_GIOTANK_GRAPH";
const ERROR_EVENTS_GIOTANK_GRAPH = "ERROR_EVENTS_GIOTANK_GRAPH";

// filters
const CHANGE_START_DATE_GIOTANK_GRAPH = "CHANGE_START_DATE_GIOTANK_GRAPH";
const CHANGE_END_DATE_GIOTANK_GRAPH = "CHANGE_END_DATE_GIOTANK_GRAPH";

// general
const CLEAR_GIOTANK_GRAPH = "CLEAR_DATA_GIOTANK_GRAPH";
const CLEAR_ERROR_GIOTANK_GRAPH = "CLEAR_ERROR_GIOTANK_GRAPH";
const SET_ERROR_GIOTANK_GRAPH = "SET_ERROR_GIOTANK_GRAPH";

const INITIAL_STATE = {
  events: [],
  isLoading: false,
  error: false,
  message: "",
  errorMessage: "",
  // graphs
  eventsAxeX: [],
  eventsAxeY: [],
  // filters
};

const giotanksGraphReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // events
    case LOAD_EVENTS_GIOTANK_GRAPH:
      return {
        ...state,
        events: [],
        isLoading: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_EVENTS_GIOTANK_GRAPH:
      return {
        ...state,
        events: payload.events,
        eventsAxeX: payload.eventsAxeX,
        eventsAxeY: payload.eventsAxeY,
        isLoading: false,
      };
    case ERROR_EVENTS_GIOTANK_GRAPH:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };

    // filters
    case CHANGE_START_DATE_GIOTANK_GRAPH:
      return {
        ...state,
        startDate: payload,
      };
    case CHANGE_END_DATE_GIOTANK_GRAPH:
      return {
        ...state,
        endDate: payload,
      };

    // general
    case CLEAR_GIOTANK_GRAPH:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case CLEAR_ERROR_GIOTANK_GRAPH:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    case SET_ERROR_GIOTANK_GRAPH:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };

    default:
      return state;
  }
};

// Actions
// events
function getEvents(id, startDate, endDate) {
  return {
    type: LOAD_EVENTS_GIOTANK_GRAPH,
    payload: {
      id,
      startDate,
      endDate,
    },
  };
}
// filters
function changeStartDate(date) {
  return {
    type: CHANGE_START_DATE_GIOTANK_GRAPH,
    payload: date,
  };
}
function changeEndDate(date) {
  return {
    type: CHANGE_END_DATE_GIOTANK_GRAPH,
    payload: date,
  };
}
//general
function setError(error) {
  return {
    type: SET_ERROR_GIOTANK_GRAPH,
    payload: error,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR_GIOTANK_GRAPH,
  };
}

function* fetchEvents(action) {
  const {
    payload: { id = "" },
  } = action;
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/giotanks/${id}/events`;

  try {
    const response = yield call(api_get, url, auth);

    const eventsAxeX = response.map((event) => event.date);
    const eventsAxeY = response.map((event) => event.gas);

    yield put({
      type: SET_EVENTS_GIOTANK_GRAPH,
      payload: {
        events: response,
        eventsAxeX,
        eventsAxeY,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_EVENTS_GIOTANK_GRAPH,
      payload: {
        message,
      },
    });
  }
}

function* giotanksGraphSaga() {
  yield takeLatest(LOAD_EVENTS_GIOTANK_GRAPH, fetchEvents);
}

export {
  // reducer
  giotanksGraphReducer,
  // actions
  getEvents,
  changeStartDate,
  changeEndDate,
  clearError,
  setError,
  // saga
  giotanksGraphSaga,
};
